import axios from "axios";
import BusyLoader from "../common/BusyLoader";
import CommonUtil from "../common/CommonUtil";

//const url = "https://devapi.rehrigbdp.com"; // old dev-api
//const url = "https://rcmapi-qa.rehrigbdp.com"; // qa api
const url = process.env.REACT_APP_SERVER_URL; //new dev-api

// axios.interceptors.request.use(
//   config => {
//       CommonUtil.getIDToken();
//       config.headers['Authorization'] = ("Bearer " + (sessionStorage.getItem("idtkn")));
//      // console.log(config);
//         return config;
//     },
//     error => {
//         return Promise.reject(error);
//     }
// );
axios.interceptors.request.use(
  config => {
      CommonUtil.getIDToken();
      if (CommonUtil.sessionKey) {
          config.headers['Authorization'] = "Bearer " + CommonUtil.sessionKey;
      }
      return config;
  },
  error => Promise.reject(error)
);

export const getAllUsers = () => {
    BusyLoader.showLoader();
  return axios.get(`${url}/api/user/all`)
    .then(res => {
        BusyLoader.hideLoader();
      return res.data
    })
    .catch(e => {
        BusyLoader.hideLoader();
      return e
    })
};

export const getUserPermissions = () => {
  BusyLoader.showLoader();
return axios.get(`${url}/api/user/permissions`)
  .then(res => {
      BusyLoader.hideLoader();
    return res.data;
  })
  .catch(e => {
      BusyLoader.hideLoader();
    return e
  })
};

export const addUserApi = (body) => {
    BusyLoader.showLoader();
  return axios.post(`${url}/api/user/`, body)
    .then(res => {
        BusyLoader.hideLoader();
      return res.data
    })
    .catch(e => {
        BusyLoader.hideLoader();
      return e
    })
}

export const editUserApi = (body) => {
    BusyLoader.showLoader();
  return axios.put(`${url}/api/user/${body.userId}`, body)
    .then(res => {
        BusyLoader.hideLoader();
      return res.data
    })
    .catch(e => {
        BusyLoader.hideLoader();
      return e
    })
}

export const deleteUser = (body) => {
    BusyLoader.showLoader();
  return axios.delete(`${url}/api/user/${body}`, )
  .then(res => {
      BusyLoader.hideLoader();
    return res
  })
  .catch(e => {
      BusyLoader.hideLoader();
    return e
  })
}

export const getAllRoles = () => {
    BusyLoader.showLoader();
  return axios.get(`${url}/api/role/all`)
    .then(res => {
        BusyLoader.hideLoader();
      return res.data
    })
    .catch(e => {
        BusyLoader.hideLoader();
      return e
    })
};


export const getRolePermissions = () => {
    BusyLoader.showLoader();
  return axios.get(`${url}/api/role/masterpermissions`)
    .then(res => {
        BusyLoader.hideLoader();
      return res.data
    })
    .catch(e => {
        BusyLoader.hideLoader();
      return e
    })
}

export const addRoleApi = (body) => {
    BusyLoader.showLoader();
  return axios.post(`${url}/api/role/`, body)
    .then(res => {
        BusyLoader.hideLoader();
      return res.data
    })
    .catch(e => {
        BusyLoader.hideLoader();
      return e
    })
}


export const editRoleApi = (id, body) => {
    BusyLoader.showLoader();
  return axios.put(`${url}/api/role/${id}`, body)
    .then(res => {
        BusyLoader.hideLoader();
      return res.data
    })
    .catch(e => {
        BusyLoader.hideLoader();
      return e
    })
}


export const deleteRole = (body) => {
    BusyLoader.showLoader();
  return axios.delete(`${url}/api/role/${body}`, )
  .then(res => {
      BusyLoader.hideLoader();
    return res
  })
  .catch(e => {
      BusyLoader.hideLoader();
    return e
  })
}

export const getRole = (body) => {
    BusyLoader.showLoader();
  return axios.get(`${url}/api/role/${body}`, )
  .then(res => {
      BusyLoader.hideLoader();
    return res.data
  })
  .catch(e => {
      BusyLoader.hideLoader();
    return e
  })
}


